import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAvatarComponent } from "./med-icon-avatar.component";

@NgModule({
  declarations: [
    MedIconAvatarComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAvatarComponent,
  ],
})
export class MedIconAvatarModule { }
